import React, { useState } from 'react'; import logo from './css/images.png';
import API_BASE_URL from '../config';
import { Link, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';  // Corrected import
import { useAuth } from '../context/AuthContext';  // Import useAuth hook

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();  // Access login function from AuthContext

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!email || !password) {
      setError('Both fields are required');
      return;
    }

    setError(''); // Reset any previous error

    try {
      // Send POST request to the backend
      const response = await fetch(`${API_BASE_URL}/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        const responseData = await response.json();
        console.error('Login failed:', responseData.message);  // Log the error from backend
        setError(responseData.message || 'An error occurred while logging in.');
        return;
      }

      const responseData = await response.json();


      // Check if the necessary tokens are returned
      if (!responseData.accessToken || !responseData.refreshToken) {
        setError('Login failed: No access or refresh tokens found');
        return;
      }

      // Store tokens and other necessary data in localStorage
      localStorage.setItem('accessToken', responseData.accessToken);
      localStorage.setItem('refreshToken', responseData.refreshToken);
      localStorage.setItem('email', email);

      // Decode the token and extract relevant information (optional)
      const decodedToken = jwtDecode(responseData.accessToken);


      // Optionally, store userId from decoded token if it's different from responseData._id
      localStorage.setItem('userId', decodedToken.id || responseData.data.id);

      // Update authentication state
      login();

      // Redirect to a protected route or dashboard
      navigate("/ips");  // Redirect to the dashboard after successful login
    } catch (error) {
      console.error('An unexpected error occurred:', error);
      setError('An unexpected error occurred while logging in');
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-[450px]">
        <div className="bg-white p-8 md:p-10 rounded-2xl shadow-xl border border-slate-100">
          <div className="flex justify-center mb-8">
            <img src={logo} alt="DeviSoft Logo" className="w-48 h-16 object-contain" />
          </div>

          <h2 className="text-2xl font-bold text-slate-800 mb-6 text-center">Welcome Back</h2>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block mb-2 text-sm font-semibold text-slate-700" htmlFor="email">
                Email Address
              </label>
              <input
                className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-slate-800 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all duration-200"
                type="email"
                id="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div>
              <label className="block mb-2 text-sm font-semibold text-slate-700" htmlFor="password">
                Password
              </label>
              <input
                className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-slate-800 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all duration-200"
                type="password"
                id="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            {error && (
              <div className="p-3 rounded-lg bg-red-50 border border-red-100 text-red-600 text-sm">
                {error}
              </div>
            )}

            <button
              className="w-full bg-blue-600 hover:bg-blue-700 text-white p-3.5 rounded-xl font-bold shadow-lg shadow-blue-200 transition-all duration-300 transform hover:-translate-y-0.5 active:translate-y-0"
              type="submit"
            >
              Sign In
            </button>

            <div className="text-center pt-4">
              <Link
                to="/forgot-password"
                className="text-sm font-medium text-blue-600 hover:text-blue-700 transition-colors"
              >
                Forgot your password?
              </Link>
            </div>
          </form>
        </div>

        <p className="text-center mt-8 text-slate-500 text-sm">
          &copy; {new Date().getFullYear()} DeviSoft. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default LoginForm;
